/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../base.model';

export class NameAndGuidDto extends BaseModel {
  public ID: string;
  public Name: string;
}
